import $http from '$http';
import { cloneDeep, util, isCorrectVal, isDate, lg } from 'utils';
import { GetParmConfig, ParmConfigDel, ParmConfigAdd } from '@api/commonApi.js';

let consts = {
    timeLabel1: "寄出日期",
    timeLabel2: "收件日期",
};

export default {
    components: {},
    props: {
        isReadOnly: {
            default () {
                return false;
            }
        }
    },
    mounted() {

    },
    computed: {
        isShowByStatus() {
            if (this.form.ContractStatusName.indexOf("寄出") > -1) {
                this.timeStr = consts.timeLabel1;
                return true;
            }
            this.timeStr = consts.timeLabel2;
            return false;
        }
    },
    data() {
        return {
            timeStr: consts.timeLabel1,
            visiable1: false,
            ContractId: "",
            AreaId: "",
            htList: [],
            form: this.initData()
        };
    },
    watch: {

    },
    methods: {
        initData() {
            return cloneDeep({
                "Consignee": "",
                "ConsigneeTel": "",
                "ConsigneeAdress": "",
                "ConsigneeTime": "",
                "ContractStatusName": "",
                "LogisticsCode": "",
                "LogisticsName": "",
                "ContractNumber": "",
                Remark: ""
            });
        },
        show(options) {

            let opts = $.extend({}, {
                AgentId: "",
                ContractId: "",
                AreaId: "",
                isReadOnly: false
            }, options);

            this.visiable1 = true;

            this.form.AgentId = opts.AgentId;

            if (opts.isReadOnly && $.trim(opts.ContractId).length > 0) {
                this.ContractId = opts.ContractId;
                this.loadDataByContractId();
            }

            if (opts.isReadOnly && $.trim(opts.AreaId).length > 0) {
                this.AreaId = opts.AreaId;
                this.loadDataByAreaId();
            }

        },
        closeCallBack() {
            this.form = this.initData();
            this.AreaId = "";
            this.ContractId = "";
            this.htList = [];
        },
        loadDataByContractId() {
            if ($.trim(this.ContractId).length == 0) {
                return;
            }

            let params = {
                Sid: this.$store.state.sysSid,
                Session: this.$store.state.sysSession,
                ContractId: this.ContractId
            };

            //GET /api/Agent/GetContractById
            $http.get("api/Agent/GetContractById", params).then(res => {
                let { Data } = res.data;
                util.doResult(this, res, () => {
                    this.form = cloneDeep($.extend({}, this.initData(), util.filterAndSetData(this.initData(), Data)));
                    this.htList.push(this.form);
                });
            });
        },
        isShowByStatus2(value) {
            if ($.trim(value).length > 0) {
                return true;
            }
            return false;
        },
        getTimeStr(value) {
            if (value.indexOf("寄出") > -1) {
                return consts.timeLabel1;
            }
            return consts.timeLabel2;
        },
        loadDataByAreaId() {

            if ($.trim(this.AreaId).length == 0) {
                return;
            }

            let params = {
                Sid: this.$store.state.sysSid,
                Session: this.$store.state.sysSession,
                AreaId: this.AreaId
            };

            //GET /api/Agent/GetContractListByAreaId
            $http.get("api/Agent/GetContractListByAreaId", params).then(res => {
                let { Data } = res.data;
                util.doResult(this, res, () => {
                    this.$nextTick(() => {
                        this.htList = Data;
                    });
                });
            });

        }
    }
};


// WEBPACK FOOTER //
// ./src/pages/CRMFormatAgent/components/viewContractStatusListDialog/vm.js